import { ACTIONS_TRANSLATE } from "./actions";
import { BREADCRUMBS_TRANSLATE } from "./breadcrumbs-translate";

export const GENERIC_TRANSLATIONS: any = {
	...BREADCRUMBS_TRANSLATE,
	root: {
		language: "en-US",
		noscript: "To view this application, please enable JavaScript.",
		title: "{{ projectName }}",
		projectName: "Fale Seguro",
		metas: {
			description: `You want information, you want an organized, productive and motivated team.
			Your company needs JoinIn. A productivity and content platform
			that simplifies processes and speeds up communication with teams.`,
			keywords: `JoinIn, tools, spaces, interaction, communication, relations,
			publications, contact, information, organization, productive, motivated,
			processes, agile, teams, dynamic structure, customizable, services,
			self-service, human resources, digital board, social network, corporate
			social network, service center, travel, digital, intranet, integration,
			approvals, requests, people, transformation, decentralization, debureaucratization,
			strategies, business`,
			author: "JoinIn",
			copyright: "JoinIn"
		},
		workWithUs: {
			first: "JoinIn team here!",
			second: "Work with us: http://joinin.com.br.",
			third: "#wearejoinin"
		}
	},

	errorDialog: {
		title: "Attention"
	},
	generic: {
		...ACTIONS_TRANSLATE,
		noResults: {
			label: "No information has been added",
			description: "When added, they will appear here.",
			filter: "Nothing was found for your search",
			message: "Change your filters and try again",
		},
	},

	boxInfo: {
		user: {
			registration: "Registration: {{identificationNumber}}",
			admission: "Admission: {{admissionDate}}",
			jobTitle: "Job Title",
			department: "Department",
			finishedAt: "Finished at",
			manager: "Manager",
		}
	},

	situations: {
		active: "Active",
		activeSingular: "Active",
		inactive: "Inactive",
		inactiveSingular: "Inactive",
		all: "All",
		allFemale: "All",
		ratings: {
			one: "1",
			two: "2",
			three: "3",
			four: "4",
			five: "5"
		},
		commentsModeration: {
			pending: "Pending",
			approve: "Approved",
			reprove: "Rejected"
		}
	},

	auxiliary: {
		lastSeparator: " and"
	},
	booleans: {
		yes: "Yes",
		no: "No",
		true: "Yes",
		false: "No"
	},
	races: {
		white: "White",
		black: "Black"
	},
	date: {
		dateAndHourSeparator: 'at',
		dateToDate: 'to',
		today: "Today",
		yesterday: "Yesterday",
		allDay: "All day"
	},

	sw: {
		title: "Update",
		content: "There is a new version of the application, please click the button below to reload the page.",
		actions: {
			reload: {
				text: "Reload page"
			}
		}
	},
	recorderAudio: {
		rejectedPermission: "You need to allow access to your microphone",
		timedOut: "Time limit reached, please send or record another audio"
	},
	snackBar: {
		messages: {
			success: "Success",
			error: "Error",
			internalServerError: "A server connection error occurred"
		},
		actions: {
			close: {
				text: "Close"
			},
			reload: {
				text: "Reload page"
			},
			restore: {
				text: "Undo"
			}
		}
	},
	errors: {
		moduleImport: "There is a new version of the application, please click the button below to reload the page.",
		connectionDown: "You lost network access",
		permissionError: "You do not have permission to access this page.",
		connectionComeBack: "Your connection has been restored",
		apiIsNotFound: "The connection to the server was lost, please contact support",
		apiError: "I couldn't load some element on this page. If this affects your usage, please contact support.",
	},

	dialog: {
		ariaLabel: "Dialog box",
		actions: {
			close: "Close",
			agree: "I agree"
		}
	},
	localActions: {
		filters: {
			text: "Filters",
			tooltip: "Filters",
			badge: "Number of active filters"
		},
		generateReport: {
			text: "Generate report",
			tooltip: "Generate report"
		}
	},
	confirmDialog: {
		title: "Attention",
		body: "Do you want to confirm the changes made?",
		action: "Yes",
		cancel: "No"
	},

	listActions: {
		edit: {
			text: "Edit"
		},
		delete: {
			text: "Delete"
		},
		close: {
			text: "Close"
		},
		save: {
			text: "Save"
		},
		duplicate: {
			text: "Duplicate"
		},
		remove: {
			text: "Remove"
		},
		recover: {
			text: "Restore"
		},
		inactive: {
			text: "Deactivate"
		},
		restorePassword: {
			text: "Restore password"
		},
		view: {
			text: "View"
		},
		reprove: {
			text: "Reject"
		},
		approve: {
			text: "Approve"
		},
		viewChanges: {
			text: "View changes"
		},
		finish: {
			text: "Finish"
		},
		active: {
			text: "Activate"
		},
		resendEmail: {
			text: "Resend confirmation email"
		}
	},
	filters: {
		title: "Filters",
		actions: {
			close: {
				text: "Close"
			},
			clear: {
				text: "Clear"
			},
			save: {
				text: "Search"
			}
		},
		fields: {
			active: {
				label: "Status",
				placeholder: "Choose the status",
				url: "status",
			}
		}
	},
	dynamicFields: {
		select: {
			placeholder: "Select one of the options"
		}
	},
	form: {
		updateSubTitle: "",
		createSubTitle: "",
		select: {
			lastSeparator: " and",
			nothing: "None",
			nothingFemale: "None",
		},
		dateRange: {
			initPlaceholder: "Start date",
			finalPlaceholder: "End date"
		},
		input: {
			password: {
				show: "Show password",
				hide: "Hide password"
			}
		},
		editor: {
			link: {
				label: "Link",
				placeholder: "Enter the link",
				save: 'Save',
				edit: 'Edit',
				remove: 'Remove',
				visitUrl: 'Visit link'
			}
		},
		chips: {
			remove: "Remove item",
			notFound: "Items not found"
		},
		autocomplete: {
			notFound: "Items not found",
			clear: "Clear"
		},
		errors: {
			maxShouldBeGreaterThanMin: "The maximum number value must be greater than the minimum number value",
			minlength: "Minimum {{ minlength }} characters",
			maxlength: "Maximum {{ maxlength }} characters",
			min: "Minimum allowed value is {{ min }}",
			max: "Maximum allowed value is {{ max }}",
			email: "Email is invalid",
			invalidOption: "Select a valid option",
			onlyNumber: "Enter numbers only",
			passwordConfirmation: "Passwords must match",
			required: "Field is required",
			matDatepickerParse: "Date is invalid",
			matStartDateInvalid: "Date is invalid",
			matEndDateInvalid: "Date is invalid",
			matDatepickerFilter: "Date is invalid",
			dateRangeMessageSeparated: "Date is invalid",
			url: "URL is invalid",
			color: "Color is invalid",
			cnpj: "CNPJ is invalid",
			cpfOrEmail: "Email or document is invalid",
			cep: "ZIP code is invalid",
			cpf: "Document is invalid",
			hourMinute: "Time is invalid",
			phone: "Phone is invalid",
			cnh: "Driver's license is invalid",
			licensePlate: "License plate is invalid",
			overSize: "File size cannot exceed 200 megabytes",
			invalidStartEndTime: "End time must not be earlier than start time",
			notANumber: "Not a number",
			whiteSpaces: "Cannot contain only whitespace"
		},
		chooseIcon: {
			messages: {
				text: "Selected: {{ icon }}",
				notFound: "None added",
			},
			buttons: {
				add: {
					text: "Add"
				},
				change: {
					text: "Change"
				}
			},
			dialog: {
				title: "Choose an icon",
				noResults: "Icons not found",
				form: {
					fields: {
						search: {
							label: "Search",
							placeholder: "Enter the icon name, category or tag"
						}
					}
				},
				buttons: {
					showMore: {
						text: "Show more"
					}
				}
			}
		},
		actions: {
			clear: {
				text: "Clear form"
			},
			cancel: {
				text: "Cancel"
			},
			create: {
				text: "Create"
			},
			save: {
				text: "Save"
			},
			close: {
				text: "Close"
			}
		}
	},

	notFound: {
		breadcrumbName: "Not Found",
		title: "Page not found",
		description: `
                You tried to access a page that does not exist. Click the button below to go back.
            `,
		actions: {
			back: {
				text: "Back"
			}
		}
	},
	noAccess: {
		breadcrumbName: "No Access",
		title: "No access permission",
		description: `
                You do not have permission to access this page. Click the button below to go back.
            `,
		actions: {
			back: {
				text: "Back"
			}
		}
	},

	table: {
		expanded: {
			column: "Expandable column",
			row: "Expandable row"
		},
		noResults: {
			text: "No results found",
			description: "Try adding or filtering an item"
		},
		paginator: {
			firstPageLabel: "First page",
			lastPageLabel: "Last page",
			itemsPerPageLabel: "Items per page",
			nextPageLabel: "Next page",
			previousPageLabel: "Previous page",
			rangeLabel: "{{ index }} to {{ limit }} of {{ length }}",
			perPageUrl: "per-page",
			pageUrl: "page"
		},
		columns: {
			actions: "",
			dragAction: {
				tooltip: "Drag to move this row"
			},
			selection: {
				all: {
					select: "Select all rows",
					deselect: "Deselect all rows"
				},
				row: {
					select: "Select this row",
					deselect: "Deselect this row"
				}
			}
		}
	},
	fileViewer: {
		actions: {
			download: "Download",
			view: "View",
			close: "Close",
		}
	},
	fileRenderer: {
		notFound: {
			label: "File unavailable",
			description: "This file could not be found",
		}
	},
	filePicker: {
		actions: {
			addMedia: "Add attachment",
			changeMedia: "Replace attachments",
		},
		noResults: {
			label: "No attachments added"
		}
	},
	hintBox: {
		labels: {
			expanded: "Hide usage tips",
			notExpanded: "Show usage tips",
		},
	},
	dynamicForm: {
		drawer: {
			title: "Add new fields",
			fields: {
				fieldName: {
					label: "Field name",
					placeholder: "The name the user will see when signing up."
				},
				fieldType: {
					label: "Field type",
					placeholder: "A text? a list of options?"
				},
				required: {
					label: "Is it required?",
					tooltip: "If you check this field, the user will not be able to submit the form without filling in this information."
				},
				onlyForParticipant: {
					label: "Show this field only to the participant?",
					tooltip: "If you check this field, only the participant that the user adds will see it."
				},
				maxLength: {
					label: "Maximum character length",
					placeholder: "How many numbers or letters can the user enter at most?"
				},
				maxNumber: {
					label: "Maximum number value",
					placeholder: "How much can the user enter in this field?"
				},
				minNumber: {
					label: "Minimum number value",
					placeholder: "How much can the user enter in this field?"
				},
			},
			configurations: {
				options: {
					title: "List options",
					tooltip: "Here you can enter the options that will be displayed in this list",
					fields: {
						name: {
							label: "Option name",
							placeholder: "This is how the user will see this option"
						}
					}
				},
			},
			actions: {
				save: {
					text: "Save"
				},
				addField: {
					text: "Add field to form"
				},
				editField: {
					text: "Edit field in form"
				},
				cancelUpdate: {
					text: "Cancel editing"
				},
			},
			errors: {
				fieldNameExists: "A field with this name already exists. Please enter another value"
			}
		},
		noResults: {
			label: "No fields have been added to the form",
			description: 'Click on "+ Add field to form" to add them'
		},
		fieldActions: {
			edit: {
				text: "Edit this field"
			},
			move: {
				text: "Move the position of this field"
			},
			delete: {
				text: "Remove this field from the form"
			},
		}
	},
	confirmAction: {
		title: "Are you sure you want to perform this action?",
		body: "This action cannot be undone",
		cancel: "Cancel",
		delete: "Yes, execute",
	},
	advancedEditor: {
		defaultActions: {
			font: {
				tooltip: "Font"
			},
			header: {
				tooltip: "Headings"
			},
			size: {
				tooltip: "Set font size",
				placeholder: "Size"
			},
			bold: {
				tooltip: "Bold"
			},
			italic: {
				tooltip: "Italic"
			},
			underline: {
				tooltip: "Underline"
			},
			strike: {
				tooltip: "Strikethrough"
			},
			align: {
				tooltip: "Alignment"
			},
			list: {
				ordered: {
					tooltip: "Add ordered list"
				},
				bullet: {
					tooltip: "Add unordered list"
				},
			},
			image: {
				tooltip: "Add image"
			},
			link: {
				tooltip: "Insert link"
			},
			background: {
				tooltip: "Select background color"
			},
			color: {
				tooltip: "Select text color"
			},
			variables: {
				tooltip: "Select variable",
				placeholder: "Variables"
			},
		},
		options: {}
	},
	list: {
		noResults: {
			text: "No results found",
			description: "Add an item and it will appear here",
		},
		moreResults: {
			text: "Show more"
		}
	},

	footer: {
		title: "Developed by"
	},
	developedBy: {
		title: "Joinin"
	},
	accountOutOfConnection: {
		label: "Problems with your authentication, please contact technical support! - ACT001"
	},
	globalLoading: {
		message: "",
		login: "Signing in to {{ projectName }}",
		loading: "Loading {{ projectName }}",
		logout: "Signing out of {{ projectName }}",
		switchUser: "Switching user",
		joinWithOtherUser: "Signing in with another user",
		authentication: "Authenticating user",
	},
	tabs: {
		urlName: "tab"
	},

	radioVote: {
		quantity: "Number of votes"
	},
	basicCarousel: {
		actions: {
			next: {
				text: "Next image"
			},
			previous: {
				text: "Previous image"
			}
		}
	},

	actions: {
		showMore: "Show more",
		seeAttachments: "View attachments",
		addObservation: "Notes",
		observationAndAttachments: "Attachments / notes",
		setAttachments: "Add attachments"
	},

	notifications: {},
	unauthorizedPage: {
		redirect: {
			back: "Back"
		}
	},
	tooltipUser: {
		edit: "Edit",
		chat: "Chat",
		congratulate: "Congratulate",
		onVacation: "On vacation",
		myProfile: "My profile",
		profile: "View profile"
	},

	uuidAuthentication: {
		messages: {
			notFound: "Account not found"
		}
	},

	attachments: {
		open: "Open attachment",
		remove: "Remove attachment"
	},

	languageSwitcher: {
		label: "Language",
		confirmTitle: "Do you want to change the language to \"{{name}}\"?",
		confirmBody: "The page needs to be reloaded to apply the changes.",
		confirm: "Confirm",
		cancel: "Cancel",
		// eslint-disable-next-line @typescript-eslint/naming-convention
		languages: {
			// eslint-disable-next-line @typescript-eslint/naming-convention
			"pt-BR": "Português (BR)",
			// eslint-disable-next-line @typescript-eslint/naming-convention
			"en-US": "English (US)",
			// eslint-disable-next-line @typescript-eslint/naming-convention
			"es-ES": "Español (ES)",
		}
	},
};
